////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div>
        <div v-if="products.length > 0" class="c-product-recommendations">
            <div class="o-container">
                <div class="c-featured-product_grid">
                    <div class="c-featured-product_grid_item -text">
                        <div class="c-featured-product_title_wrap">
                            <h2 class="c-featured-product_title" data-scroll data-scroll-speed="1">
                                <slot name="title"></slot>
                            </h2>
                        </div>
                    </div>

                    <div v-for="(product, index) in limitProducts" :key="index" class="c-featured-product_grid_item">
                        <product-recommendations-item
                            ref="tile"
                            :title="product.title"
                            :images="product.images"
                            :handle="product.handle"
                            :created-at="product.createdAt"
                            :price-range="product.priceRange"
                            :compare-at-price-range="product.compareAtPriceRange"
                            :available-for-sale="product.availableForSale"
                            :currency-iso-code="currencyIsoCode"
                            :currency-symbol="currencySymbol"
                            :not-available-label="notAvailableLabel"
                            :new-label="newLabel"
                            :sale-label="saleLabel"
                            :from-product-label="fromProductLabel"
                            :add-to-cart-label="addToCartLabel"
                            :go-to-product-label="goToProductLabel"
                            :variants-obj="product.variants"
                            :current-lang-code="currentLangCode"
                            :custom-alternative-image="product.alternativeImage"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////

export default function VueProductRecommendations(moduleInstance) {

    Vue.component("product-recommendations", {

        template,

        props: {
            productId: {
                type: String,
                required: true
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            notAvailableLabel: {
                type: String,
                required: true
            },
            newLabel: {
                type: String,
                required: true
            },
            saleLabel: {
                type: String,
                required: true
            },
            addToCartLabel: {
                type: String,
                required: true
            },
            fromProductLabel: {
                type: String,
                required: true
            },
            goToProductLabel: {
                type: String,
                required: true
            },
            currentLangCode: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                products: []
            };
        },

        computed: {
            limitProducts() {
                return this.products.slice(0, 3);
            }
        },

        created() {

        },

        async mounted() {
            /////////////////////
            // Global ID
            // https://github.com/Shopify/mobile-buy-sdk-ios/issues/663#issuecomment-311369782
            // https://community.shopify.com/c/Shopify-APIs-SDKs/Getting-Global-ID/td-p/520191
            /////////////////////
            const baseGlobalId = `gid://shopify/Product/${this.productId}`
            const gid = btoa(baseGlobalId)

            const products = await moduleInstance.getProductRecommandations(gid)

            if (typeof products === 'object' && products.length > 0) {
                this.products = products
            }

            /////////////////////
            // Update scroll
            this.$nextTick(() => {
                moduleInstance.call('update', null, 'Scroll');
            })
        },


        methods: {
            /////////////////
            // Callbacks
            /////////////////
        }
    });
}
